// extracted by mini-css-extract-plugin
export default {"VerifyRestCode":"verifyRestCode_VerifyRestCode__Tlnv9"};